<template>
  <div class="page-export-test">
    <div id="printContent">
      <header>
        <h3>{{ this.hwName }}</h3>
        <div class="header-info">
          <h3>姓名:</h3>
          <h3>班级:</h3>
        </div>
      </header>
      <section>
        <!-- 题目内容 -->
        <div
          class="test-info"
          v-for="(qItem, index) in this.questionList"
          :key="index"
        >
          <p class="test-info__head">
            <span class="test-info__head__left"
              >{{ index + 1 }}、{{ questionName(qItem.question_type) }}</span
            >
            <span class="test-info__head__right"
              >难度:{{ qItem.difficulty }}</span
            >
          </p>
          <div class="test-info__body">
            <div v-katexHtml="htmlDeCode(qItem.body.content)" />
            <div v-if="qItem.body.img_data.length">
              <img
              v-for="(img, index) in qItem.body.img_data"
              :key="index"
              :src="img.source"
              />
            </div>
          </div>
          <!-- 答题选项 -->
          <ul v-if="qItem.question_type === 1 || qItem.question_type === 2"
            class="test-info__answer">
            <li
              v-for="(option, index) in qItem.option"
              :key="index"
              class="test-info__answer__item"
            >
              <span>{{ option.key }}.</span>
              <div
                class="item"
                v-if="option.content"
                v-katexUbb="htmlDeCode(option.content)"
              />
              <span
                v-else-if="isNumber(option.content)"
                v-html="option.content"
              />
              <span v-else v-katex="htmlDeCode(option.answer)" />
            </li>
          </ul>
        </div>
        <!-- 题目解析 -->
        <div id="answer" v-if="showAnswer == 1">
          <h1 class="answer__head">答题解析</h1>
          <div
            class="answer__body"
            v-for="(items, index) in this.questionList"
            :key="index"
          >
            <div class="answer-content">
              <div class="reference-version" v-if="items.answer">
                <p class="reference-version__title">
                  {{ index + 1 }}、参考答案
                </p>
                <div
                  class="answer-content__style"
                  v-for="(items, index) in items.answer"
                  :key="index"
                >
                  <div
                    v-for="(item, index) in items"
                    :key="index"
                    class="text-content-title"
                    v-katexUbb="htmlDeCode(item.content)"
                  ></div>
                </div>
              </div>
              <div class="text-analysis" v-if="items.analyze">
                <p class="text-analysis__head">文字解析</p>
                <div
                  class="answer-content__style"
                  v-for="(items, index) in items.analyze"
                  :key="index"
                >
                  <div
                    v-for="(item, index) in items"
                    :key="index"
                    class="text-content-title"
                    v-katexHtml="item.content"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <footer>
      <div class="stamp" @click="print">打印</div>
      <div class="go-top" @click="goToTop">
        <i class="el-icon-top" />回到顶部
      </div>
    </footer>
  </div>
</template>

<script>
import { htmlDecodeByRegExp, getSign } from '@/utils';
import { getContentDetail } from '@/api/pt';

export default {
  name: 'ExportTest',
  data() {
    const { showAnswer } = this.$route.query;
    return {
      hwName: '',
      showAnswer,
      showButton: false,
      questionList: [], // 题目列表
      qOptions: [], // 选项列表
    };
  },
  computed: {
    questionName() {
      const arr = ['未定义', '单选题', '多选题', '填空题'];
      return (num) => arr[num];
    },
  },
  async created() {
    await this.getContentDetail();
  },
  methods: {
    // 转换html字符串
    htmlDeCode(str) {
      return htmlDecodeByRegExp(str, 1);
    },
    getContentDetail() {
      const { teacherId, serialNum } = this.$route.query;
      const params = { teacher_id: teacherId, serial_num: serialNum, is_analysis: 1 };
      const sign = getSign(params);
      const query = `is_analysis=1&serial_num=${serialNum}&teacher_id=${teacherId}&sign=${sign}`;
      return getContentDetail(query).then((res) => {
        if (res.code === 200) {
          this.questionList = Object.values(res.data.question_info);
          this.hwName = res.data.exercise_name;
          this.questionList.forEach((item, index) => {
            this.qOptions = item.option;
            if (!item.body && item.content) {
              const newdata = item;
              newdata.body = item.content;
              newdata.option = item.options;
              newdata.body.img_data = item.content.image;
              if (typeof item.answer === 'string') {
                newdata.answer = [[{ content: item.answer }]];
              }
              this.$set(this.questionList, index, newdata);
            }
          });
        }
      });
    },
    print() {
      window.print();
      window.location.reload();
    },
    goToTop() {
      window.scroll(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.page-export-test {
  background: #ffffff;
  padding: 30px 20px 0px;
  font-family: "PingFangSC-Medium", "PingFang SC";
}
header {
  text-align: center;
  border-bottom: 1px dotted rgba(25, 31, 37, 0.2);
  font-size: 22px;
  font-weight: 500;
  color: #111f2c;
  margin-top: 10px;
  // background: url("~@/views/pt/images/logo.png") no-repeat left top;
  // background-size: 140px;
  .header-info {
    display: flex;
    justify-content: space-evenly;
    margin-top: 30px;
    margin-bottom: 24px;
    font-size: 14px;
    font-weight: 500;
    color: #111f2c;
    h3::after {
      content: "";
      width: 189px;
      height: 1px;
      display: inline-block;
      background: #111f2c;
      border-bottom: 1px solid #111f2c;
      margin-left: 10px;
    }
  }
}
section {
  background: url("~@/views/pt/images/watermark.png");
  background-size: 700px;
  .test-info {
    margin-top: 20px;
    border-bottom: 6px solid #f2f4f5;
    page-break-inside: avoid;
    // padding-bottom: 10px;
    .test-info__head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      font-size: 14px;
      .test-info__head__left {
        font-weight: 900;
        color: #111f2c;
      }
      .test-info__head__right {
        font-weight: 400;
        color: rgba(17, 31, 44, 0.56);
      }
    }
    .test-info__body {
      font-size: 14px;
      line-height: 30px;
    }
    .test-info__answer {
      display: flex;
      flex-wrap: wrap;
      margin-top: 5px;
      &__item {
        display: flex;
        // flex-wrap: wrap;
        padding: 0 10px;
        align-items: center;
        min-width: 180px;
        min-height: 28px;
        background: #ffffff;
        border-radius: 12px;
        border: 1px solid #a3a5a8;
        font-size: 14px;
        line-height: 30px;
        margin-right: 24px;
        margin-bottom: 8px;
        span {
          border-right: 1px solid #e3e4e4;
          padding-right: 16px;
          margin-right: 15px;
        }
        .item {
          display: inline-block;
        }
      }
    }
  }
}
#answer {
  .answer-content__style {
    font-size: 14px;
    font-weight: 400;
    color: #111f2c;
    margin-top: 16px;
  }
  .answer__head {
    text-align: center;
    margin-top: 34px;
    padding-bottom: 20px;
    font-size: 20px;
    font-weight: 900;
    color: #111f2c;
  }
  .answer-content {
    font-size: 14px;
    line-height: 30px;
    font-weight: 500;
    color: #111f2c;
    padding-bottom: 6px;
    border-bottom: 6px solid #f2f4f5;
    .reference-version {
      border-bottom: 1px solid rgba(17, 31, 44, 0.12);
      padding-top: 8px;
      &__title {
        font-weight: 900;
        font-size: 14px;
      }
    }
    .text-analysis {
      margin-top: 8px;
      position: relative;
      .text-analysis__head {
        margin-left: 10px;
        font-weight: 900;
        &::before {
          content: "";
          position: absolute;
          height: 14px;
          border-left: 2px solid #0089ff;
          border-radius: 1px;
          top: 3px;
          left: 0px;
        }
      }
    }
  }
}
footer {
  position: fixed;
  right: 0px;
  top: 50%;
  .stamp {
    height: 80px;
    width: 80px;
    border-radius: 50%;
    background: #1989fa;
    line-height: 80px;
    text-align: center;
    font-size: 22px;
    font-weight: 500;
    color: #ffffff;
    border: 5px solid #f2f4f5;
  }
  .go-top {
    width: 95px;
    height: 30px;
    background: #ffa82d;
    border-radius: 33px 0px 0px 33px;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
    line-height: 30px;
    text-align: center;
    margin-top: 36px;
  }
}
@media print {
  @page {
    margin-top: 0;
    margin-bottom: 0;
  }
  header {
    -webkit-print-color-adjust: exact;
    -moz-print-color-adjust: exact;
    -ms-print-color-adjust: exact;
    background: url("~@/views/pt/images/logo.png") no-repeat left top;
    background-size: 140px;
  }
  section {
    -webkit-print-color-adjust: exact;
    -moz-print-color-adjust: exact;
    -ms-print-color-adjust: exact;
    background: url("~@/views/pt/images/watermark.png");
    background-size: 700px;
  }
  footer {
    display: none;
  }
  h1 {
    page-break-before: always;
  }
}
</style>
